export default __webpack_public_path__ + "static/media/user-dark.922adb28.svg";